import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { HelperService } from 'src/app/shared/utils/helper.service';
import {
  UserRoleAccessControl,
  activeRoles,
  Page,
} from 'src/app/shared/utils/user-roles';

@Directive({
  selector: '[accessControl]',
})
export class AccessControlDirective {
  userRole = this.helperService.getUserRole; // get from server side as per discussion right now we have not getting property from server side

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainerRef: ViewContainerRef,
    private helperService: HelperService
  ) {}

  @Input() set accessControl(right: string[]) {
    let accessControls1: any;
    if (activeRoles.includes(this.userRole)) {
      const pages: Page[] = this.helperService.getUserAccessibilityMatrix;
      accessControls1 = pages.find((page) => page.name === right[0]);
    } else {
      accessControls1 = UserRoleAccessControl.find(
        (user) => user.roleName === this.userRole
      )?.pages.find((page) => page.name === right[0]);
    }

    if (accessControls1[right[1]]) {
      this.viewContainerRef?.createEmbeddedView(this.templateRef);
    } else {
      this.viewContainerRef.clear();
    }
  }
}
